import { Component, Input, OnInit } from "@angular/core";
import { constantUrl } from "src/app/Shared/constantUrl";

@Component({
    selector: "app-customer-subcard-info",
    templateUrl: "./customer-subcard-info.component.html",
    styleUrls: ["./customer-subcard-info.component.scss"],
    standalone: false
})
export class CustomerSubcardInfoComponent implements OnInit {
  @Input() customerData: any;
  profileUrl: any;

  readonly customerTypeMap: { [key: string]: string } = {
    H: "Borrower",
    C: "CoBorrower",
    G: "Guarantor",
  };

  constructor() {}

  ngOnInit(): void {
    const customerTypeMap: { [key: string]: string } = {
      H: "Borrower",
      C: "CoBorrower",
      G: "Guarantor",
    };

    this.customerData.AC_CustomerType =
      customerTypeMap[this.customerData.AC_CustomerType as string] ||
      this.customerData.AC_CustomerType;

    this.profileUrl = `${constantUrl.customerProfilePicUrl}${this.customerData.CustomerId}/${this.customerData.Customer_ProfilePic}`;
  }
}
